'use strict';

var React = require('react'),
    _ = require('underscore'),
    Button = require('../atoms/Button'),
    Icon = require('../atoms/Icon'),
    Counter = require('../atoms/Counter'),
    UserImage = require('../atoms/UserImage'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    SidebarActionCreators = require('../actions/SidebarActionCreators'),
    SidebarTypes = require('../constants/SidebarTypes'),
    PropTypes = React.PropTypes;

var PendingZineButton = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    size: PropTypes.oneOf(['medium', 'large']).isRequired,
    zine: PropTypes.object.isRequired,
    pendingStampUsers: PropTypes.arrayOf(
      PropTypes.object.isRequired
    ).isRequired
  },

  getDefaultProps: function () {
    return {
      size: 'medium'
    };
  },

  render: function () {
    var zine = this.props.zine;

    return (
      <Button size={this.props.size}
              color='red'
              onClick={this.handleClick}
              className='Btn--pending'
              context='PageControls'
              fill>
        <Icon name='notification'
              mode='stroke' />
        <Counter count={zine.pendingCount}
                 context='PendingZineButton' />
        {this.renderPendingUsers()}
      </Button>
    );
  },

  renderPendingUsers() {
    return _.take(this.props.pendingStampUsers, 3).map(user =>
      <UserImage user={user}
                 size='xsmall'
                 context='PageControls'
                 hideOnMobile />
    );
  },

  handleClick: function () {
    SidebarActionCreators.showSidebar(SidebarTypes.ZINE_PENDING_STAMPS, {
      zineSlug: this.props.zine.slug
    });
  }
});

module.exports = PendingZineButton;



/** WEBPACK FOOTER **
 ** ./molecules/PendingZineButton.jsx
 **/